import { Action, createReducer, on } from '@ngrx/store';
import * as MoveWizardStoreActions from './actions';
import { State, initialState } from './state';

export const moveWizardStoreFeatureKey = 'moveWizardStoreV26';

const moveWizardStoreReducer = createReducer(
  initialState,

  on(MoveWizardStoreActions.selectMoveInitStep, (state, { initStep }) => ({
    ...state,
    initStep,
    dueDatesStep: { moveDate: null },
  })),
  on(MoveWizardStoreActions.selectConsumerStep, (state, { consumerStep }) => ({
    ...state,
    initStep: {
      ...state.initStep,
      desk: consumerStep,
      userId: consumerStep.consumerUserId,
      deskId: consumerStep.consumerDeskId,
      cancelAll: true,
      deskStart: consumerStep.consumerStarts,
    },
  })),
  on(MoveWizardStoreActions.deleteConsumerStep, (state) => ({
    ...state,
    initStep: {
      ...state.initStep,
      desk: null,
      userId: null,
      deskId: null,
      cancelAll: true,
      deskStart: null,
    },
    fromDeskStep: null,
  })),
  on(MoveWizardStoreActions.selectToDeskStep, (state, { toDeskStep }) => ({
    ...state,
    toDeskStep,
  })),
  on(MoveWizardStoreActions.selectDueDatesStep, (state, { dueDatesStep }) => ({
    ...state,
    dueDatesStep,
  })),
  on(MoveWizardStoreActions.selectFromDeskStep, (state, { fromDeskStep }) => ({
    ...state,
    fromDeskStep,
  })),
  // on(MoveWizardStoreActions.selectLicenseStep, (state, { licenseStep }) => ({
  //   ...state,
  //   licenseStep,
  // })),
  on(MoveWizardStoreActions.exitAllocationMoveWizard, (state) => ({
    ...state,
    initStep: null,
    dueDatesStep: null,
    fromDeskStep: null,
    toDeskStep: null,
    errorMessage: null,
  })),
  on(MoveWizardStoreActions.destroyWizard, (state) => ({
    ...state,
    initStep: null,
    dueDatesStep: null,
    fromDeskStep: null,
    toDeskStep: null,
    errorMessage: null,
  })),
  // on(MoveWizardStoreActions.sendLicenseServicesCancelRequest, (state, { cancelRequest }) => ({
  //   ...state,
  //   cancelRequest,
  // })),
  // on(MoveWizardStoreActions.cancelRequestSuccess, (state, { response }) => ({
  //   ...state,
  //   cancelLicenseServicesResponse: response,
  // })),
  // on(MoveWizardStoreActions.cancelRequestFail, (state, { errorMessage }) => ({
  //   ...state,
  //   errorMessage,
  // }))
);

export function reducer(state: State | undefined, action: Action) {
  return moveWizardStoreReducer(state, action);
}
